import React from 'react'
import {Container, Row, Col, Carousel} from "react-bootstrap"
import {Link} from "react-router-dom"
/* LISTA VEICOLI */
import Lamborghini from "../../style/Img/Lamborghini/LamborghiniHuracane.jpg"
import Audi from "../../style/Img/Audi/Audi A3.jpg"
import Panda from "../../style/Img/Panda/Panda.jpg"
import Bmw from "../../style/Img/Bmw/Bmw s1000rr.jpg"
import Kawasaki from "../../style/Img/Kawasaki/Kawasaki z750.jpg"
import Vespa from "../../style/Img/Vespa/Vespa.jpg"
import MountainBike from "../../style/Img/Bici/Mountain Bike.jpg"
import BiciCorsa from "../../style/Img/Bici/Bici da Corsa.jpg"
import BiciPasseggio from "../../style/Img/Bici/Bici da Passeggio.jpg"
import Monopattino1 from "../../style/Img/Monopattini/Monopattino1.jpeg"
import Monopattino2 from "../../style/Img/Monopattini/Monopattino2.jpg"
import Monopattino3 from "../../style/Img/Monopattini/Monopattino3.jpg"
import Zoom from 'react-reveal/Zoom';

function ListaVeicoli() {
    return (
        <Container fluid>
            {/* SEZIONE BANNER */}
            <Container fluid id="banner_recovered" className="head-banner text-center text-white">
                <Container>
                    <Row >
                        <Col className="mx-auto">
                            <h1><strong>8-Bit Motors</strong></h1>
                        </Col>
                    </Row>
                </Container>
            </Container>

            {/* SEZIONE CATALOGO */}
            <Container>
            <Row>
        <Col className="col-lg-6 mr-3 mt-3 testo sezione-immagini" >
            <h2>Automobili</h2>
            <p>Se quello che cerchi è un po` di adrenalina automobilistica, ma pensi che il prezzo di listino
                di questo tipo di veicolo è esorbitante? Tranquillo! Ci pensiamo noi, con le nostre offerte e i nostri
                prezzi concorrenti potrai coronare il tuo sogno. Oppure semplicemente sei in vacanza nelle nostre terre
                o semplicemente al momento non hai un mezzo disponibile? Pensiamo anche a queste eventualità con delle
                semplicissime macchine utilitarie, insomma ce n'è per tutti i gusti!
            </p>
        </Col>
        <Col className="col-lg-6 mt-3">
            <Zoom>
        <Carousel>
            <Carousel.Item>
            <Link to="/listaVeicoli/listaAuto"><img
                className="d-block w-100"
                src={Lamborghini}
                alt="Third slide"
                /></Link>
            </Carousel.Item>
            <Carousel.Item>
            <Link to="/listaVeicoli/listaAuto"><img
                className="d-block w-100"
                src={Audi}
                alt="Third slide"
                /></Link>
            </Carousel.Item>
            <Carousel.Item>
                <Link to="/listaVeicoli/listaAuto"><img
                className="d-block w-100"
                src={Panda}
                alt="Third slide"
                /></Link>
                
            </Carousel.Item>
        </Carousel>
        </Zoom>
        </Col>
    </Row>

    <Row>
        <Col className="col-lg-6 mt-3 testo sezione-immagini order-lg-1" >
            <h2>Motocicli</h2>
            <p>Se invece l'avere un'automobile di tutto di rispetto non vi dovesse bastare, il nostro Catalogo
                vi offre anche una ricca collezione di moto sulle quali saltare in sella e provare il brivido
                della velocità o nel caso in cui vogliate fare una viaggio più tranquillo, la vespa è lo scooter
                che fa al caso vostro!
            </p>
        </Col>
        <Col className="col-lg-6 mt-3">
        <Zoom>
        <Carousel>
            <Carousel.Item>
            <Link to="/listaVeicoli/listaMoto"><img
                className="d-block w-100"
                src={Bmw}
                alt="Third slide"
                /></Link>
            </Carousel.Item>
            <Carousel.Item>
            <Link to="/listaVeicoli/listaMoto"><img
                className="d-block w-100"
                src={Kawasaki}
                alt="Third slide"
                /></Link>
            </Carousel.Item>
            <Carousel.Item>
            <Link to="/listaVeicoli/listaMoto"><img
                className="d-block w-100"
                src={Vespa}
                alt="Third slide"
                /></Link>
            </Carousel.Item>
        </Carousel>
        </Zoom>
        </Col>
    </Row>

    <Row>
        <Col className="col-lg-6 mt-3 testo sezione-immagini" >
            <h2>Biciclette</h2>
            <p>Se quello che cerchi è semplicemente del relax, la bicicletta è proprio quello che fa al caso
                tuo. Abbiamo diversi tipi di Biciclette dalle Mountain Bike alle BMX, insomma nessuno può
                restare scontento!
            </p>
        </Col>
        <Col className="col-lg-6 mt-3">
        <Zoom>
        <Carousel>
            <Carousel.Item>
            <Link to="/listaVeicoli/listaBici"><img
                className="d-block w-100"
                src={MountainBike}
                alt="Third slide"
                /></Link>
            </Carousel.Item>
            <Carousel.Item>
            <Link to="/listaVeicoli/listaBici"><img
                className="d-block w-100"
                src={BiciCorsa}
                alt="Third slide"
                /></Link>
            </Carousel.Item>
            <Carousel.Item>
            <Link to="/listaVeicoli/listaBici"><img
                className="d-block w-100"
                src={BiciPasseggio}
                alt="Third slide"
                /></Link>
            </Carousel.Item>
        </Carousel>
        </Zoom>
        </Col>
    </Row>

    <Row>
        <Col className="col-lg-6 mr-3 mt-3 testo sezione-immagini order-lg-1" >
            <h2>Monopattini</h2>
            <p>Infine il nostro catalogo vi propone una scelta di monopattini che ultimamente stanno prendendo
                sempre più piede nella società odierna grazie alle sue emissioni 0 e al suo facile trasporto
                questo mezzo risulta ottimale nel caso in cui dobbiate fare lunghissimi tragitti e muovervi
                per le strade cittadine!
            </p>
        </Col>
        <Col className="col-lg-6 mt-3">
        <Zoom>
        <Carousel>
            <Carousel.Item>
            <Link to="/listaVeicoli/listaMonopattini"><img
                className="d-block w-100"
                src={Monopattino1}
                alt="Third slide"
                /></Link>
            </Carousel.Item>
            <Carousel.Item>
            <Link to="/listaVeicoli/listaMonopattini"><img
                className="d-block w-100"
                src={Monopattino2}
                alt="Third slide"
                /></Link>
            </Carousel.Item>
            <Carousel.Item>
            <Link to="/listaVeicoli/listaMonopattini"><img
                className="d-block w-100"
                src={Monopattino3}
                alt="Third slide"
                /></Link>
            </Carousel.Item>
        </Carousel>
        </Zoom>
        </Col>
    </Row>

            </Container>
        </Container>
    )
}

export default ListaVeicoli
